import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import HomePage from '../../components/HomePage';
import { fetchUserDetailsDispatch } from '../../actions';

const mapStateToProps = (state, ownProps) => {
  const user = state.users.user && state.users.user.item;
  return {
    userRole: user.role
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchUserDetails: (userEmail) => {
      dispatch(fetchUserDetailsDispatch(userEmail));
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HomePage)
);
